/** Extract contribution id from map deep link `?contribution=<uuid>`. */
export function contributionIdFromActionUrl(actionUrl: string | null | undefined): string | null {
  if (!actionUrl) return null;
  try {
    return new URL(actionUrl).searchParams.get('contribution');
  } catch {
    return null;
  }
}
